import { createAction } from '@reduxjs/toolkit'

import { TAzureAdBody } from 'types/GlobalAuthentication'

// tryGetAzureAd
export const getAzureAd = createAction('get_azure_ad')
export const getAzureAdSuccess = createAction<TAzureAdBody['data']>(
  'get_azure_ad_success'
)
export const getAzureAdFailed = createAction('get_azure_ad_failed')

// tryPutAzureAd
export const putAzureAd = createAction('put_azure_ad')
export const putAzureAdSuccess = createAction<TAzureAdBody['data']>(
  'put_azure_ad_success'
)
export const putAzureAdFailed = createAction('put_azure_ad_failed')

// tryDeleteAzureAd
export const deleteAzureAd = createAction('delete_azure_ad')
export const deleteAzureAdSuccess = createAction('delete_azure_ad_success')
export const deleteAzureAdFailed = createAction('delete_azure_ad_failed')
